import { useTranslation } from "react-i18next"
import { useEffect, useState } from "react"

import Form from "./Form"
import { AdminFormDialog } from "components/partials"
import {
	toRow,
	toTableData,
	getFormTitle
} from "common/helpers/admin-page-func.helper"
import { useAdminState, useAdminDispatch, ActionCreators } from "../Context"
import { CompaniesApi } from "../api"
import { LocalStorageKey } from "common/helpers"
import { useLocalStorage } from "common/hooks"

const Dialog = () => {
	const { t } = useTranslation()
	const dispatch = useAdminDispatch()
	const { rowToEdit, params } = useAdminState()
	const { filter, pagination } = params

	const [currentUser, setUserInLocalStorage] = useLocalStorage(
		LocalStorageKey.User
	)

	const formData = Boolean(rowToEdit) ? { ...rowToEdit } : {}
	const isEditMode = Boolean(formData.id)

	const [isDialogOpen, setIsDialogOpen] = useState(false)

	useEffect(() => {
		const hasFormData = Boolean(rowToEdit && Object.entries(rowToEdit).length)
		setIsDialogOpen(hasFormData)
	}, [rowToEdit])

	function onExited() {
		dispatch(ActionCreators.setToEdit(null))
	}

	function onClose() {
		setIsDialogOpen(false)
	}

	async function submitCallback(formData) {
		const requestFunc = isEditMode ? CompaniesApi.update : CompaniesApi.create

		const payload = formData
		if (!isEditMode && formData.licenses === undefined) {
			payload.licenses = 0
		}

		const response = await requestFunc(payload)
		const companyResponse = response.data

		if (currentUser.company?.id === companyResponse.id) {
			setUserInLocalStorage({ ...currentUser, company: companyResponse })
		}

		if (!filter || !pagination) {
			dispatch(ActionCreators.addRow(toRow(companyResponse)))
			return
		}

		onClose()
		CompaniesApi.get({ filter, pagination, refetch: true }).then(response => {
			dispatch(ActionCreators.loaded(toTableData(response)))
		})
	}

	function onClickDelete() {
		dispatch(ActionCreators.setToDelete([rowToEdit]))
	}

	return (
		<AdminFormDialog
			formData={formData}
			submitCallback={submitCallback}
			FormComponent={Form}
			DialogProps={{
				open: isDialogOpen,
				onClose,
				TransitionProps: {
					onExited
				}
			}}
			DialogTitleProps={{
				children: getFormTitle(
					t("view.admin.company"),
					isEditMode ? "edit" : "create"
				)
			}}
			{...(isEditMode && { onClickDelete })}
		/>
	)
}

export default Dialog
